/* global angular */
( function () {
	'use strict';

	function reportForm ( ) {
		return {
			'templateUrl' : '/templates/report/report-components/report-form/report-form.html',
			'restrict'    : 'E',
			'transclude'  : true,
			'scope'       : {
				'reportTitle'    : '@',
				'generateReport' : '&',
				'hasData'        : '='
			}
		};
	}

	angular
		.module( 'app.report' )
		.directive( 'reportForm', reportForm );
} )( );
